import { useEffect, useState } from 'react';

export const useCalculateRowsPerPage = (rowHeight: number = 11): number => {
  const [rowsPerPage, setRowsPerPage] = useState(rowHeight); // Default fallback

  useEffect(() => {
    const calculateRowsPerPage = () => {
      // Get the available height for the table (approx viewport minus headers/footers)
      // We subtract an estimate for headers, padding, etc.
      const availableHeight = window.innerHeight - 300;
      // Calculate how many rows can fit
      const calculatedRows = Math.max(
        5,
        Math.floor(availableHeight / rowHeight),
      );
      setRowsPerPage(calculatedRows);
    };

    // Calculate initially
    calculateRowsPerPage();

    // Recalculate on window resize
    window.addEventListener('resize', calculateRowsPerPage);
    return () => window.removeEventListener('resize', calculateRowsPerPage);
  }, [rowHeight]);

  return rowsPerPage;
};
